import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'
import axios from 'axios';
import {handlePicPlusPre,isExistCity} from '../util/util';
Vue.use(Vuex);
const state = {
  // 需求类型数据
  requirementTypeData: {
    // 出行人数
    travelNumberType: [
      {
        id: 1,
        name: "25人以下",
      },
      {
        id: 2,
        name: "25-50人",
      },
      {
        id: 3,
        name: "50-100人",
      },
      {
        id: 4,
        name: "100-150人",
      },
      {
        id: 5,
        name: "150-200人",
      },
      {
        id: 6,
        name: "200人以上",
      },
    ],
    meetingNumberType: [
      {
        id: 1,
        name: "30-100人",
      },
      {
        id: 2,
        name: "100-200人",
      },
      {
        id: 3,
        name: "200-400人",
      },
      {
        id: 4,
        name: "400-1000人",
      },
      {
        id: 5,
        name: "1000人以上",
      },
    ],
    // 人均价格
    avgBudgetType: [
      {
        id: 1,
        name: "300元以下",
      },
      {
        id: 2,
        name: "300-500",
      },
      {
        id: 3,
        name: "500-1000",
      },
      {
        id: 4,
        name: "1000-2000",
      },
      {
        id: 5,
        name: "2000以上",
      },
    ],
    // 天数类型
    dayType: [
      {
        id: 1,
        name: "半天",
      },
      {
        id: 2,
        name: "一天",
      },
      {
        id: 3,
        name: "两天",
      },
      {
        id: 4,
        name: "三天",
      },
      {
        id: 5,
        name: "四天",
      },
      {
        id: 6,
        name: "五天",
      },
      {
        id: 7,
        name: "六天",
      },
      {
        id: 8,
        name: "一周",
      },
    ],
    meetingType:[],
    webInfo: {},//网站基本信息
    isNextMethod:"",
  },
  // 短信倒计时
  SMSCountdown:0,
  // 使用腾讯云后
  picPreUrl: '',
  videoUrl: '',
  // pdf前缀
  // pdfUrl: 'http://www.lxqtj.com:8000',
  // pdf前缀
  VUE_APP_BASE_API: '/dev-api',
  // picPreUrl: 'http://localhost:8000',
  // 图片附加地址
  // picPreUrl: 'http://www.lxqtj.com:8000',
    // videoUrl: 'http://localhost',
    // 视频附加地址
  // videoUrl: 'http://www.lxqtj.com:8000',
  // picPreUrl:'/dev-api',
  // defaultpricelist: '',
  //正式
  pdfPreUrl: 'http://www.lxqtj.com:8000',
  BASEURL: 'http://www.lxqtj.com:8001',

  //测试107
  // pdfPreUrl: 'http://119.91.138.107:8000',
  // BASEURL: 'http://119.91.138.107:8001',
  //测试
  // pdfUrl: 'http://localhost:8000',
  // BASEURL: 'http://localhost:8001',
  // BASEURL: 'http://119.91.138.107:8001',
  // pdfUrl: 'http://119.91.138.107:8000',
  //网站基本信息
  webInfo: {},
  // 玩法类型
  playTypeList:[],
  serviceArray: [],
  //查询中心城市
  siteCityList: [],
  //当前站点城市
  locationSiteCity: "",
  //当前站点城市电话
  locationCityPhone: "",
  //当前站点城市默认电话
  defaultCityPhone: "0755-23208261",
  // 年会免费定制是否显示
  annualMeetingCustomState: false,
  isLoadingCity:false,
  // 分享
  // 默认图像
  // defaultPic:"http://www.lxqtj.com:8000/profile/upload/common/lxqicon.png",
  defaultPic:"https://lxq-1312465796.cos.ap-guangzhou.myqcloud.com/2024/05/08/lxqIcon_20240508160604A057.png",
  defaultTitle:"蓝星球团建~",
  defaultDesc:"一站式服务平台",
}

const actions = {
    //网站基本信息
    getWebInfo({state,commit}){
      axios.get(`/api/config/getConfig`).then((res) => {
        this.loading = false;
        if (res.data.code == 200 && res.data.data) {
          commit('saveWebInfo', res.data.data.siteConfig)
          commit('savePlayTypeList', res.data.data.playTypeList)
        } 
      })
    },
  // 获取年会类型
  getMeetingCondition({ state, commit }){
    axios.get("/api/meeting/meetingCondition").then((res) => {
      console.log(res)
      if (res.data && res.data.code == 200) {
        commit('saveMeetingType', res.data.meeting)
      }
    });
  },
  //获取站点城市
  getSiteCityList({ state, commit }) {
    axios.get(`/api/city/site`).then((res) => {
      this.loading = false;
      if (res.data.code == 200) {
        commit('saveSiteCityList', res.data.siteList)
        if (res.data.siteList && res.data.siteList.length > 0 && (this.state.locationSiteCity == "" || !isExistCity(res.data.siteList,this.state.locationSiteCity))) {
          console.log("--获取站点城市--saveLocationCityPhone")
          commit("saveLocationSiteCity", res.data.siteList[0].cityId)
          commit("saveLocationCityPhone", res.data.siteList[0].cityPhone)
        }
        commit("saveIsLoadingCity",false);
      } 
    }).catch(e=>{
      console.log(e)
      commit("saveIsLoadingCity",false);
    })
  },
  // 初始获取站点城市
    getInitSiteCityList({ state, commit }) {
      axios.get(`/api/city/initSite`).then((res) => {
        this.loading = false;
        let that =this;
        if (res.data && res.data.code == 200) {
          commit('saveSiteCityList', res.data.siteList)
          if (this.state.locationSiteCity == "" || !isExistCity(res.data.siteList,this.state.locationSiteCity)) {
            console.log("--初始获取站点城市1--saveLocationCityPhone")
            commit("saveLocationSiteCity", res.data.nowSiteMap.cityId)
            commit("saveLocationCityPhone", res.data.nowSiteMap.cityPhone)
            console.log(that.state.locationCityPhone)
            console.log("--初始获取站点城市--saveLocationCityPhone")
          }
        } 
        commit("saveIsLoadingCity",false);
      }).catch(e=>{
        console.log(e)
        this.dispatch("getSiteCityList");
      })
    },
  //网站基本信息
  getWebInfo({state,commit}){
    axios.get(`/api/config/getConfig`).then((res) => {
      this.loading = false;
      if (res.data.code == 200 && res.data.data) {
        commit('saveWebInfo', res.data.data.siteConfig)
        commit('savePlayTypeList', res.data.data.playTypeList)
      } 
    })
  },
};


const mutations = {
  saveAnnualMeetingCustomState(state, item) {
    state.annualMeetingCustomState = item
  },
  saveSiteCityList(state, item) {
    state.siteCityList = item
  },
  saveLocationSiteCity(state, item) {
    state.locationSiteCity = item
  },
  saveLocationCityPhone(state, item) {
    state.locationCityPhone = item
  },
  saveSMSCountdown(state, item) {
    state.SMSCountdown = item
  },
  saveMeetingType(state, item) {
    state.requirementTypeData.meetingType = item
  },
  saveWebInfo(state, item) {
    if(item){
      if(item.wxNo){
        item.wxNo = handlePicPlusPre(item.wxNo)
      }
      if(item.logo){
        item.logo = handlePicPlusPre(item.logo)
        item.logo =  item.logo[0];
      }
      if(item.customQrCode){
        item.customQrCode = handlePicPlusPre(item.customQrCode)
        item.customQrCode =  item.customQrCode[0];
      }
      if(item.customQrCodePic){
        item.customQrCodePic = handlePicPlusPre(item.customQrCodePic)
        item.customQrCodePic =  item.customQrCodePic[0];
      }
      if(item.indexBottomImage){
        item.indexBottomImage = handlePicPlusPre(item.indexBottomImage)
        item.indexBottomImage =  item.indexBottomImage[0];
      }
    }
    state.webInfo = item
  },
  savePlayTypeList(state, item) {
    state.playTypeList = item
  },
  saveIsLoadingCity(state, item) {
    state.isLoadingCity = item
  },
  saveIsNextMethod(state, item) {
    state.isNextMethod = item
  },
  clearIsNextMethod(state) {
    if(state.isNextMethod){
    clearInterval(state.isNextMethod);
    state.isNextMethod = "";
  }
  },
}

const getters = {

};



export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  plugins: [
    createPersistedState({ storage: window.sessionStorage })
  ]
})



// WEBPACK FOOTER //
// ./src/vuex/store.js